import React from 'react';
import { UI_CAPTION_DF } from 'oolib';
import { TooltipTextProps, TooltipLink } from '../types';

const defaultContainerStyle: React.CSSProperties = {
    padding: '0.8rem',
    maxWidth: '30rem',
};

// Simple link renderer (without OKELink dependency)
const renderLink = (link: TooltipLink, linkStyle?: React.CSSProperties) => {
    return (
        <a
            href={link.href}
            target={link.newTab ? '_blank' : undefined}
            rel={link.newTab ? 'noopener noreferrer' : undefined}
            style={{
                color: 'inherit',
                textDecoration: 'underline',
                ...linkStyle,
            }}
        >
            {link.text}
        </a>
    );
};

export default function TooltipText({
    text,
    link,
    containerStyle,
    textStyle,
    linkStyle,
}: TooltipTextProps) {
    const position = link?.position || 'end';
    const linkElement = link ? renderLink(link, linkStyle) : null;

    return (
        <div style={{ ...defaultContainerStyle, ...containerStyle }}>
            <UI_CAPTION_DF style={textStyle}>
                {position === 'start' && linkElement}
                {position === 'start' && linkElement && text && ' '}
                {text}
                {position === 'end' && linkElement && text && ' '}
                {position === 'end' && linkElement}
            </UI_CAPTION_DF>
        </div>
    );
}
